import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      //   border: '2px solid purple',
      width: '100%',
      minHeight: '40px',
      backgroundColor: '#F7F7F7',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    text: {
      color: '#F37320',
      fontSize: '13px',
      fontWeight: 'bold',
      letterSpacing: '0',
      marginLeft: '12px',
    },
  }),
  { index: 1 },
)

export { useStyles }
